// extracted by mini-css-extract-plugin
export var author = "blockquote-module--author--82ef8";
export var blockquote = "blockquote-module--blockquote--aa8a5";
export var category = "blockquote-module--category--d4916";
export var headline = "blockquote-module--headline--d540b";
export var headlinePost = "blockquote-module--headline-post--8bee1";
export var paragraph = "blockquote-module--paragraph--afba3";
export var quoteIcon = "blockquote-module--quoteIcon--d940c";